import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleMenuItemClick = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/home">
            <img src="/Logo.png" alt="Brand Logo" />
          </Link>
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <Link to="/home" className="navbar-link" onClick={handleMenuItemClick}>Home</Link>
          </li>
          <li className="navbar-item">
            <Link to="/about" className="navbar-link" onClick={handleMenuItemClick}>About Us</Link>
          </li>
          <li className="navbar-item">
            <Link to="/services" className="navbar-link" onClick={handleMenuItemClick}>Solar Panel Cleaning Service</Link>
          </li>
          <li className="navbar-item">
            <Link to="/contact" className="navbar-link" onClick={handleMenuItemClick}>Contact Us</Link>
          </li>
        </ul>
        <div className="navbar-social">
          <a href="https://www.facebook.com/profile.php?id=61559766597754&mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer" className="navbar-icon">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="navbar-icon">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://wa.me/03095195765" target="_blank" rel="noopener noreferrer" className="navbar-icon">
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
